import React from "react";

function CostPerClickIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#37367D" rx="5"></rect>
            <path
                fill="#fff"
                d="M42 28.4c-.01.382-.242.71-.638.901l-4.954 2.417 4.34 4.341a.381.381 0 010 .54l-4.15 4.149a.38.38 0 01-.538 0l-4.34-4.342-2.418 4.957c-.19.395-.52.627-.9.637h-.027c-.445 0-.829-.275-.938-.675l-4.628-17.26c-.106-.4-.021-.762.238-1.02.255-.256.627-.343 1.02-.239l17.257 4.63c.41.108.687.505.676.965zm-19.16 2.394c-1.575-.2-3.001-.901-4.124-2.026a7.061 7.061 0 01-2.083-5.027c0-1.9.74-3.686 2.084-5.03 2.772-2.772 7.283-2.772 10.055 0a7.052 7.052 0 012.025 4.126.817.817 0 001.62-.207 8.672 8.672 0 00-2.49-5.073c-3.41-3.41-8.956-3.41-12.365 0A8.69 8.69 0 0015 23.741c0 2.336.91 4.531 2.562 6.183a8.652 8.652 0 005.07 2.49.817.817 0 00.207-1.62zm3.409-9.556c.24.238.442.508.603.803a.816.816 0 101.433-.782 5.18 5.18 0 00-8.201-1.177 5.142 5.142 0 00-1.515 3.659c0 1.382.538 2.682 1.515 3.659.35.35.746.647 1.176.883a.815.815 0 001.108-.324.817.817 0 00-.323-1.109 3.55 3.55 0 01-.806-.605 3.519 3.519 0 01-1.037-2.504c0-.946.368-1.836 1.037-2.505a3.546 3.546 0 015.01.002z"
            ></path>
        </svg>
    );
}

export default CostPerClickIcon;
